var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62529 3.23574C4.62529 2.40869 5.29834 1.73564 6.12539 1.73564C6.95244 1.73564 7.62549 2.40869 7.62549 3.23574V4.36081C7.62549 5.18787 6.95244 5.86091 6.12539 5.86091C5.29834 5.86091 4.62529 5.18787 4.62529 4.36081V3.23574ZM6.12539 6.61096C7.36597 6.61096 8.37554 5.60139 8.37554 4.36081V3.23574C8.37554 1.99516 7.36597 0.985596 6.12539 0.985596C5.52882 0.986257 4.95687 1.22354 4.53503 1.64538C4.11319 2.06722 3.87591 2.63917 3.87524 3.23574V4.36081C3.87524 5.60139 4.88481 6.61096 6.12539 6.61096Z",
    fill: "#535969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0007 7.7356H4.25046C3.35554 7.73639 2.4975 8.09225 1.8647 8.72505C1.2319 9.35786 0.876039 10.2159 0.875244 11.1108C0.875244 11.2103 0.914756 11.3057 0.985086 11.376C1.05542 11.4463 1.15081 11.4858 1.25027 11.4858C1.34973 11.4858 1.44512 11.4463 1.51545 11.376C1.58578 11.3057 1.62529 11.2103 1.62529 11.1108C1.62609 10.4148 1.90292 9.74756 2.39506 9.25542C2.88721 8.76327 3.55447 8.48644 4.25046 8.48564H8.0007C8.6967 8.48644 9.36396 8.76327 9.8561 9.25542C10.3482 9.74756 10.6251 10.4148 10.6259 11.1108C10.6259 11.2103 10.6654 11.3057 10.7357 11.376C10.806 11.4463 10.9014 11.4858 11.0009 11.4858C11.1004 11.4858 11.1958 11.4463 11.2661 11.376C11.3364 11.3057 11.3759 11.2103 11.3759 11.1108C11.3751 10.2159 11.0193 9.35786 10.3865 8.72505C9.75366 8.09225 8.89562 7.73639 8.0007 7.7356Z",
    fill: "#535969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonB);
export default __webpack_public_path__ + "static/media/personB.114401db34da9a38789205d352e83414.svg";
export { ForwardRef as ReactComponent };